<div fxLayout="row" class="select-file">
    <input id="upload-file" type="file" class="input-file" [accept]="extensions" [multiple]="isMultipleFileUpload"
        [disabled]="disabled" (change)="uploadFiles($event.target)" />

    <label class="input-label" for="upload-file" [style.opacity]="hasSelectedFile ? '0' : '1'">
        <span class="input-label-bold">{{placeholder}}</span>
    </label>
</div>